import React from 'react';

import { publicClouds } from './payload';
import { ProductSection } from '../../spe-ne';

export const PublicCloudSection = () => (
  <ProductSection
    id="spe-public-cloud"
    title="Public cloud"
    payload={publicClouds}
    background="gray"
    arrowType="blue-arrow"
  />
);
